import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_TOKEN_KEY = 'radius_admin_token';

export const adminApi = axios.create({
  baseURL: `${BASE_URL}/api/admin`,
  timeout: 15000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export function adminErrorMsg(e) {
  if (e?.response?.status === 429) return 'Too many login attempts, try again in a minute';
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return e?.message || 'Something went wrong';
}
